import 'rxjs/add/operator/do';
import 'rxjs/add/observable/throw';

import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { HttpHandler, HttpInterceptor } from '@angular/common/http';

@Injectable()
export class AtxHttpClientInterceptorResponse implements HttpInterceptor {
    public intercept(req, next: HttpHandler) {
        return next.handle(req).pipe(catchError((error) => Observable.throw(error.error.error)));
    }
}
